import { render, staticRenderFns } from "./ChangePlanModal.vue?vue&type=template&id=4b6ff36a&"
import script from "./ChangePlanModal.vue?vue&type=script&lang=js&"
export * from "./ChangePlanModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePlanModal.vue?vue&type=style&index=0&id=4b6ff36a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports